// (c) chaehongee. Confidential and proprietary.

import { uploadNode } from '../../../services/node'
import type { NodeResponse } from 'models-ts/node'

/**
 * Exports the current mask and uploads it as a new node to the session.
 * Returns the created node or null if export/upload fails.
 */
export async function uploadMaskNode(
    sessionId: string,
    exportMask: () => Promise<Blob | null>
): Promise<NodeResponse | null> {
    try {
        const blob = await exportMask()
        if (!blob) {
            console.warn('Failed to export mask')
            return null
        }
        const file = new File([blob], 'mask.png', { type: 'image/png' })
        return await uploadNode(file, sessionId, 'mask')
    } catch (error) {
        console.error('Failed to upload mask node:', error)
        return null
    }
}
